import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Table } from 'reactstrap';
import { api } from 'services/api';
import { RowList, THeadList } from './DueListTable';
import { updateOrderWeek } from './DueListTable';
import { RenderRowList } from './DueListTable';


const FilteredSoModal = ({ so, onClose, orderStatus, weList, reload, endpoint }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (so) {
      api.get(`/logisticMapFilter/?documentNumber=${so}`)
        .then((res) => {
          console.log("Dados recebidos no FilteredSoModal:", res.data.results); // 👈 AJUDA NO DEBUG
          setOrders(res.data.results);
        })
        .catch((err) => console.error("Erro ao carregar dados do FilteredSoModal:", err))
        .finally(() => setLoading(false));
    }
  }, [so]);


  const getFilterOrderStatus = (ordersStatus) => (idOrder) => {
    const status = ordersStatus?.filter((statusRelation) =>
      statusRelation.order_status?.includes(idOrder)
    );
    if (status?.length > 0) {
      return [status[0], ordersStatus.indexOf(status[0])];
    }
    return null;
  };

  const filterOrderStatus = getFilterOrderStatus(orderStatus);

  return (
    <Modal isOpen toggle={onClose} size="xl">
      <ModalHeader toggle={onClose}>Due List - SO: {so}</ModalHeader>
      <ModalBody>
        {loading ? (
          <p>Loading...</p>
        ) : orders.length === 0 ? (
          <p>Not any register for this SO</p>
        ) : (
          <Table striped responsive>
            <THeadList isFilteredView={true} />
            <tbody>
              {Array.isArray(orders) && orders.map((order, i) => (
                <RowList
                  key={`filtered-row-${order.id}`}
                  order={order}
                  i={i}
                  filterOrderStatus={filterOrderStatus}
                  reload={reload}
                  endpoint={endpoint}
                  ordersStatus={orderStatus}
                  weList={weList}
                  updateOrderWeek={updateOrderWeek}
                  isFilteredView={true}
                />
              ))}
            </tbody>
          </Table>
        )}
      </ModalBody>
    </Modal>
  );
};

export default FilteredSoModal;
